/**
 * External dependencies
 */
import {merge,  mergeWith, cloneDeep, isEmpty, initial, reduce, last, isString } from 'lodash';


/**
 * Given an action object or thunk, returns an updated object or thunk which
 * will include additional data in the action (as provided) when dispatched.
 *
 * @param  {(Function|Object)} action Action object or thunk
 * @param  {Object}            data   Additional data to include in action
 * @return {(Function|Object)}        Augmented action object or thunk
 * @see client/state/utils/withEnhancers for a more advanced alternative
 */
export function extendAction(action, data) {
	if ('function' !== typeof action) {
		return merge({}, action, data);
	}

	return (dispatch, getState) => {
		const newDispatch = (a) => dispatch(extendAction(a, data));
		return action(newDispatch, getState);
	};
}

/**
 * [createReducer description]
 *
 * @type {[type]}
 */
export const createReducer = (initialState, handlers) => {
	const reducer = (state = initialState, action) => {
		const { type } = action;

		if (handlers.hasOwnProperty(type)) {
			return handlers[type](state, action);
		}

		return state;
	};

	return reducer;
};

/**
 * [description]
 * 
 * @param  {[type]} type    [description]
 * @param  {[type]} payload [description]
 * @param  {[type]} meta    [description]
 * @return {[type]}         [description]
 */
export const createAction = (type, payload, meta) => ({
	type,
	payload,
	meta
})


export const applyEdits = (obj, edits) => {
    return mergeWith(cloneDeep(obj), edits, (objectValue, srcValue, key) => {
        if (Array.isArray(srcValue)) {
            return srcValue;
        }
    });
};

export const appendToEditsLog = (editsLog, newEdits) => {
    if (isEmpty(editsLog)) {
        return [newEdits];
    }

    const lastEdits = last(editsLog);

    if (isString(lastEdits)) {
        return [...editsLog, newEdits];
    }

    const newEditsLog = initial(editsLog);
    newEditsLog.push(mergeEdits(lastEdits, newEdits));
    return newEditsLog;
};


export const mergeEdits = (...editsLog) =>
    reduce(
        editsLog,
        (mergedEdits, nextEdits) => {
            // filter out save markers
            if (isString(nextEdits)) {
                return mergedEdits;
            }

            // return the input object if it's the first one to merge (optimization that avoids cloning)
            if (mergedEdits === null) {
                return nextEdits;
            }

            // proceed to do the merge
            return mergeWith(cloneDeep(mergedEdits), nextEdits, (objValue, srcValue, key, obj, src, stack) => {
                if (Array.isArray(srcValue)) {
                    return srcValue;
                }
            });
        },
        null,
    );
